import React, { FC } from 'react';
import { DEFAULT_HEIGHT } from './consts';
import { Skeleton, ISkeletonProps } from './Skeleton';

export const Rect: FC<ISkeletonProps> = ({ width, height = DEFAULT_HEIGHT, ...props }) => (
  <Skeleton width={width} height={height} {...props}>
    <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
  </Skeleton>
);
